"use client";
import { usePageStore } from "@/app/zustand/usePageStore";
import SmallImagesNewsCard from "../../Helper/SmallImagesNewsCard";
import Title from "../../Helper/Title";
import NewsArticle from "./NewsArticle";
import { useEffect } from "react";
import { MobileAdUnit, NewsDetailTopAd, SidebarAd } from "../../AdsBox/AdsBox";
import { useIsMobile } from "@/app/Hooks/useIsMobile";
import { usePathname } from "next/navigation";

const PostDetails = ({ articleData }) => {
  const isMobile = useIsMobile();
  const setIsDetailPage = usePageStore((s) => s.setIsDetailPage);
  const pathname = usePathname();

  useEffect(() => {
    // /preview page pe false rhega
    setIsDetailPage(pathname !== "/preview");

    return () => {
      setIsDetailPage(false);
    };
  }, [pathname]);
  const design = (
    <>
      {/* Ads Section */}
      {/* <div className="block md:hidden">
        <MobileAdUnit />
      </div> */}

      {/* <div className="hidden md:block">
        <NewsDetailTopAd />
      </div> */}
      {/* Ads  Section*/}

      <div className="container mx-auto pt-5 ">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* CENTER (Main News) */}
          <main className="order-1 lg:order-2  lg:col-span-6">
            <NewsArticle {...articleData} />
          </main>

          {/* LEFT SIDEBAR */}

          <aside className="order-2 lg:order-1 lg:col-span-3  lg:px-0">
            {/* related news */}

            {articleData?.related_news?.length > 0 && (
              <>
                <div className="mb-5">
                  <Title size="18px">जरूर पढ़ें</Title>
                </div>

                <div className="space-y-5 ">
                  {articleData?.related_news?.map((related_news, index) => (
                    <div key={index} className="border-b pb-3">
                      <SmallImagesNewsCard
                        key={index}
                        title="खेल"
                        subtitle={related_news?.title}
                        image={related_news?.thumbnail}
                        href={related_news?.permalink}
                        imageAlt={related_news?.thumbnail_alt}
                        isVideo={related_news?.is_video}
                        showDot
                        showMainTitle
                        imagePosition="left"
                        imageWidth={100}
                        imageHeight={67}
                        fontWeight="800"
                        subtitleProps={{
                          size: "15px",
                          lineHeight: "20px",
                          className: "cursor-pointer",
                        }}
                      />
                    </div>
                  ))}
                </div>
              </>
            )}
          </aside>

          {/* RIGHT SIDEBAR */}
          <aside className="order-3 lg:order-3 lg:col-span-3  ">
            {/* {isMobile ? <MobileAdUnit /> : <SidebarAd />} */}
            {/* related news */}
            <div className="mb-5 mt-4">
              <Title size="18px">वायरल खबरें</Title>
            </div>

            <div className="space-y-5">
              {articleData?.viral_news?.map((viral_news, index) => (
                <div key={index} className="border-b pb-3">
                  <SmallImagesNewsCard
                    key={index}
                    subtitle={viral_news?.title}
                    image={viral_news?.thumbnail}
                    imageAlt={viral_news?.thumbnail_alt}
                    showDot
                    showMainTitle
                    imageWidth={100}
                    imageHeight={67}
                    fontWeight="800"
                    isVideo={viral_news?.is_video}
                    href={viral_news?.permalink}
                    subtitleProps={{
                      size: "15px",
                      lineHeight: "20px",
                      className: "cursor-pointer",
                    }}
                  />
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
  return design;
};

export default PostDetails;
